var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFriends(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.9876 26.5C27.1217 23.2857 24.135 20.8732 20.6001 19.725C22.2945 18.7175 23.6112 17.1815 24.3479 15.3531C25.0847 13.5246 25.2007 11.5049 24.6783 9.60408C24.1558 7.70329 23.0237 6.0266 21.456 4.8316C19.8882 3.63659 17.9714 2.98938 16.0001 2.98938C14.0288 2.98938 12.1121 3.63659 10.5443 4.8316C8.9765 6.0266 7.84442 7.70329 7.32197 9.60408C6.79951 11.5049 6.91557 13.5246 7.65233 15.3531C8.38908 17.1815 9.70577 18.7175 11.4001 19.725C7.86524 20.8732 4.87854 23.2857 3.01262 26.5C2.92101 26.6507 2.87256 26.8237 2.87256 27C2.87256 27.1764 2.92101 27.3493 3.01262 27.5C3.09809 27.6533 3.22333 27.7806 3.37513 27.8686C3.52693 27.9566 3.69967 28.002 3.87512 28H28.1251C28.3006 28.002 28.4733 27.9566 28.6251 27.8686C28.7769 27.7806 28.9021 27.6533 28.9876 27.5C29.0792 27.3493 29.1277 27.1764 29.1277 27C29.1277 26.8237 29.0792 26.6507 28.9876 26.5V26.5Z",
    fill: "#4D4D4D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFriends);
export default __webpack_public_path__ + "static/media/Friends.5a611b48ac56b4af01462e7d259e1270.svg";
export { ForwardRef as ReactComponent };